// import React from 'react'
import webbg from "../assets/img/webbg.png";
import staranimate from "../assets/img/staranimate.png";
import { Link } from 'react-router-dom';
import React, { useState } from "react";

import { Helmet } from "react-helmet-async";

export default function Contact() {
     const [formData, setFormData] = useState({
    name: "",
    email: "",
    subjectLine: "",
    contact: "",
    message: ""
  });

  // Input change handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault(); // prevent page reload

    try {
      // ✅ PHP backend ko call
      const res = await fetch("/form.php", {
        method: "POST",
        body: new FormData(e.target), // ya: JSON.stringify(formData)
      });

      if (res.ok) {
        alert("Message sent successfully!");
        setFormData({ name: "", email: "", subjectLine: "", contact: "", message: "" });
      } else {
        alert("Failed to send message.");
      }
    } catch (err) {
      console.error(err);
      alert("Server error!");
    }
  };

  return (
    <>
        <Helmet>
            <title>Contact Us</title>
            <meta name="description" content="Our expert staff can provide you with top-notch website development services in Ghaziabad. As the best website development company in Ghaziabad, we offer unique designs, robust development, and an exceptional user experience." />
        </Helmet>
    <section class="inntepagesection">
        <div class="outerofinnterpage" style={{
                backgroundImage: `url(${webbg})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                }}
                >
            <div class="background-overlay overlay-about-bnr"></div>
            <div class="container">
                <div class="innerpagecontent">
                    <div class="staranimate">
                        <img src={staranimate} alt='star icon' />
                    </div>
                    <h2>Contact Us</h2>
                    <ul>
                        <li>
                            <Link to="/">Home <span>></span></Link>
                        </li>
                        <li>
                            <Link to="/contact-us">Contact Us</Link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>

        <section className="sectionpadding" style={{
                backgroundImage: `url(${webbg})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                }}>
            <div className="background-overlay overlay-contacts-page"></div>
            <div className="outerofcontactus">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                            <div className="contactform">
                                <div className="sectionheading">
                                    <h2>Feel free to write</h2>
                                    <p></p>
                                </div>
                                <form onSubmit={handleSubmit} id="emailForm">
                                    <div className="row">
                                        <div className="col-md-6 col-sm-12 mb-3 mt-3">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="name"
                                            placeholder="Enter Name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                        </div>

                                        <div className="col-md-6 col-sm-12 mb-3 mt-3">
                                        <input
                                            type="email"
                                            className="form-control"
                                            name="email"
                                            placeholder="Enter Email Id"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                        </div>

                                        <div className="col-md-6 col-sm-12 mb-3 mt-3">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="subjectLine"
                                            placeholder="Enter Subject"
                                            value={formData.subjectLine}
                                            onChange={handleChange}
                                            required
                                        />
                                        </div>

                                        <div className="col-md-6 col-sm-12 mb-3 mt-3">
                                        <input
                                            type="tel"
                                            pattern="[0-9]{10}" // 10 digit validation
                                            className="form-control"
                                            name="contact"
                                            placeholder="Enter Phone Number"
                                            value={formData.contact}
                                            onChange={handleChange}
                                            required
                                        />
                                        </div>

                                        <div className="col-md-12 col-sm-12 mb-3 mt-3">
                                        <textarea
                                            className="form-control"
                                            name="message"
                                            placeholder="Message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            required
                                        ></textarea>
                                        </div>
                                    </div>

                                    <button type="submit" className="btn btn-primary">
                                        Send Message
                                    </button>
                                    </form>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                            <div className="contactdetails">
                                <div className="sectionheading">
                                    <h2>Get in touch with us</h2>
                                    <p>Please contact us and we will respond as soon as possible. We eagerly await your response!</p>
                                </div>
                                <div className="detailsofcontact">
                                    <ul>
                                        <li>
                                            <div className="boxofdetail">
                                                <div className="contacticonbox">
                                                    <i className="fa fa-phone" aria-hidden="true"></i>
                                                </div>
                                                <div className="contactinfo">
                                                    <p><b>Have any question?</b></p>
                                                    <a href="tel:+919540 815 561">+91-9540 815 561</a>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="boxofdetail">
                                                <div className="contacticonbox">
                                                    <i className="fa fa-envelope-o" aria-hidden="true"></i>
                                                </div>
                                                <div className="contactinfo">
                                                    <p><b>Email-Id</b></p>
                                                    <a href="mailto:stockcode245@gmail.com">stockcode245@gmail.com</a>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="boxofdetail">
                                                <div className="contacticonbox">
                                                    <i className="fa fa-location-arrow" aria-hidden="true"></i>
                                                </div>
                                                <div className="contactinfo">
                                                    <p><b>Address</b></p>
                                                    <a href="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d111989.15941160578!2d77.31262754687246!3d28.69977876980846!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cf1bb41c50fdf%3A0xe6f06fd26a7798ba!2sGhaziabad%2C%20Uttar%20Pradesh!5e0!3m2!1sen!2sin!4v1690481871776!5m2!1sen!2sin" target="blank">Ghaziabad Uttar Pradesh Pin:201102</a>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}
